import { styled, Input as TamaguiInput, ColorTokens } from 'tamagui';

/**
 * Generic Input component built with Tamagui's styled() API.
 * Follows project conventions: uses design tokens for colors, spacing, radius.
 * Designed for reuse throughout the app with consistent styling.
 *
 * Key features:
 * - No border on focus (prevents border showing when selected)
 * - Uses tertiary50 background color by default
 * - Consistent padding and font size
 * - Placeholder color from design tokens
 */
export const StyledInput = styled(TamaguiInput, {
  // Base styling
  backgroundColor: '$tertiary50',
  paddingHorizontal: '$4',
  fontSize: '$1',
  borderWidth: 0,
  // "colorMuted" is introduced in light theme but does not exist by default.
  placeholderTextColor: '$colorMuted' as ColorTokens,
  color: '$color',
  borderRadius: '$true',
  minHeight: '$true',

  // Remove border and outline on focus
  focusStyle: {
    borderWidth: 0,
    outlineWidth: 0,
  },

  // Hover state
  hoverStyle: {
    backgroundColor: '$tertiary75',
  },

  // Disabled state
  disabledStyle: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
});
